import React, { useEffect, useState } from "react";
import { Editor, EditorMountEvent, EditorTools, EditorUtils, ProseMirror } from "@progress/kendo-react-editor";
import { Input, TextArea } from "@progress/kendo-react-inputs";
import { updatedSchema } from "../../editor/editor-schema/schema";
import { formTools } from "../../editor/editorSettings/editorToolsSettings";
import { formEditorInputRule } from "../../editor/editorSettings/inputRuleSettings";
import { sanitizeHTML } from "../../shared/validators/validator";
import "../Forms/styles/FormCanvas.scss";
import { FORM_ICONS_UPDATED } from "./FormsConstant";

const { EditorView, EditorState } = ProseMirror;
const { imageResizing } = EditorUtils;

export const TableFormField = ({ element, formData, onFieldPropertiesChange }) => {
  return (
    <table className='table'>
      <thead>
        <tr>
          {element?.properties?.columns?.map((column) => (
            <th key={column.id} className='border'>
              <Input
                value={column.title}
                onChange={(e) =>
                  onFieldPropertiesChange(element?.id, {
                    columns: element?.properties?.columns?.map((c) => (c.id === column.id ? { ...c, title: e.target.value } : c)),
                  })
                }
              />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {element?.properties?.columns?.map((column) => (
            <td key={column.id} className='border'>
              {/* <Input disabled={true} /> */}
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
};

export const TextComponent = ({ element, formData, onFieldPropertiesChange, isSelected, onLabelChange }) => {
  return (
    <div className={isSelected ? 'text-component--active' : ''}>
      {isSelected ? (
        <TextArea
          disabled={!isSelected}
          type='text'
          value={element?.properties?.value}
          onChange={(e) => onLabelChange(element.id, e.target.value)}
          autoFocus={true}
          placeholder='Type your text here'
          rows={2}
          resizable='vertical'
        />
      ) : (
        <div className='inline-label-text d-flex align-items-center' style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          <span className='element-type-icon mr-3 '>{FORM_ICONS_UPDATED["text-label"]}</span>{" "}
          <span>{element?.properties?.value || "Type your text here"}</span>
        </div>
      )}
    </div>
  );
};

export const AdvTextComponent = ({ element, isSelected, onLabelChange }) => {
  const handleMount = (event) => {
    const state = event.viewProps.state;
    let { schema } = state;
    const customSchema = updatedSchema(schema);
    const plugins = [...state.plugins, formEditorInputRule(state.schema.nodes), imageResizing()];
    return new EditorView(
      { mount: event.dom },
      {
        ...event.viewProps,
        schema: customSchema, // <-- use our schema
        state: EditorState.create({ doc: state.doc, plugins }),
      }
    );
  };

  return (
    <div>
      {isSelected ? (
        <div className=' adv-text-editor ydoc-editor dt-kendo-editor'>
          <Editor
            value={element?.properties?.value}
            onChange={(e) => {
              onLabelChange(element.id, e.html);
            }}
            autoFocus={true}
            defaultEditMode='div'
            tools={formTools}
            onMount={handleMount}
          />
        </div>
      ) : (
        <div>
          {element?.properties?.value ? (
            <div
              className='adv-text-renderer'
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(element?.properties?.value) }}
              style={{
                wordWrap: "break-word",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                maxWidth: "100%",
                overflow: "hidden",
              }}
            />
          ) : (
            <div className='inline-label-text' style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
              <span className='element-type-icon mr-2 '>{FORM_ICONS_UPDATED["advanced-text"]}</span> <span>Type your text here</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
